import React, { useEffect, useMemo, useState } from "react";
import LinksComponent from "../../../../components/Tenant/LinksComponent/LinksComponent";
import { Menu } from "@headlessui/react";
import { HiOutlinePlus } from "react-icons/hi";
import DataTableComponent from "../../../../components/Tenant/DataTableComponent/DataTableComponent";
import { AiOutlineDelete, AiOutlineEdit } from "react-icons/ai";
import { toast } from "react-hot-toast";
import { GrDocumentPdf } from "react-icons/gr";
import { Link, useNavigate } from "react-router-dom";
import { hasPermission } from "../../../../utils/hasPermission";
import { getVendorName } from "../../../../utils/getVendorName";
import ImageModal from "../../../../components/Tenant/ImageModal/ImageModal";
import ModalComponent from "../../../../components/Tenant/ModalComponent/ModalComponent";
import { CgFontSpacing, CgReorder } from "react-icons/cg";
import { useEmployeeLevelMutation, useFetchAllEmployeeMutation, useTransferEmployeeMutation, useUpateEmployeeMutation, useUpateEmployeeStatusMutation, useUploadEmployeeCsvMutation } from "../../../../features/tenant/Employee/employeeApi";
import { downloadSampleCSV } from "../../../../utils/downloadSampleCsv";
import { useAddEmployeeLevelMutation, useFetchAllEmployeeLevelMutation } from "../../../../features/tenant/Employee/employeeLevelApi";
import { TbTransfer } from "react-icons/tb";
import LevelAddModal from "./LevelAddModal";

const EmployeeLevel = () => {
    const primaryColor = JSON.parse(sessionStorage.getItem("vendorTheme")).theme
        .color_shades;
    const [allEmployeeData, setAllEmployeeData] = useState([])
    const [showLevelModal, setShowLevelModal] = useState(false);

    const [
        fetchAllEmployee,
        {
            data: fetchAllEmployeeData,
            isLoading: fetchAllEmployeeIsLoading,
            isError: fetchAllEmployeeIsError,
            error: fetchAllEmployeeError,
        },
    ] = useFetchAllEmployeeLevelMutation();

    const [
        addEmployeeLevel,
        {
            data: addEmployeeLevelData,
            isLoading: addEmployeeLevelIsLoading,
            isError: addEmployeeLevelIsError,
            error: addEmployeeLevelError,
        },
    ] = useAddEmployeeLevelMutation();

    const getAllEmployeeFunc = () => {
        fetchAllEmployee({
            token: sessionStorage.getItem("access_token"),
            tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
        });

    }
    useEffect(() => {
        getAllEmployeeFunc()
    }, []);

    useEffect(() => {
        if (fetchAllEmployeeData && fetchAllEmployeeData?.body) {
            setAllEmployeeData(fetchAllEmployeeData?.body || [])
        }
        if (fetchAllEmployeeIsError) {
            toast.error("Error in fetching Employee Level List")
        }
    }, [fetchAllEmployeeData, fetchAllEmployeeIsError])

    useEffect(() => {
        if (addEmployeeLevelData && addEmployeeLevelData?.body) {
            toast.success("Employee Levels Added Successfully");
            getAllEmployeeFunc();
        }
        if (addEmployeeLevelError) {
            toast.error("Error in fetching Employee Level List")
        }
    }, [addEmployeeLevelData, addEmployeeLevelError])

    const columns = [
        {
            name: "SNo",
            cell: (row, idx) => Number(idx + 1),
        },
        {
            name: "Level ID",
            cell: (row) => <div className="text-sm text-gray-600">{row.id || "-"}</div>,
        },
        {
            name: "Name",
            cell: (row) => (
                <div>
                    <span className="font-medium text-gray-800">{row.level_name || "-"}</span>
                </div>
            ),
        },
        {
            name: "Sequence",
            cell: (row) => <div className="text-sm text-gray-600">{row.level_order || "-"}</div>,
        }
    ];

    const handleSaveLevels = (levels) => {
        console.log("FINAL HIERARCHY:", levels);

        if(!levels || levels.length === 0){
            toast.error("No levels to save");
            return;
        }

        const body = levels.reverse().map((lvl,idx) => ({ level_name: lvl.name.trim(), level_order: idx+1 }));
        console.log("API BODY:", body);
        addEmployeeLevel({
            token: sessionStorage.getItem("access_token"),
            tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
            body: {
                rows: body
            }
        });
    };

    return (
        <>
            <div className="flex w-full bg-gray-200 h-full justify-center">
                <div className="w-full ">
                    <div className="border-b bg-white border-gray-300 pl-6 py-2 shadow-sm text-xl font-bold">
                        Employee Level
                        <LinksComponent />
                    </div>
                    <div className="p-3">
                        <div className="p-3 w-full bg-white shadow rounded-lg">
                            <DataTableComponent
                                keyField={(row) => row.SNo}
                                columns={columns}
                                data={
                                    allEmployeeData
                                }
                                pagination={false}
                            >
                                <div className="flex m-2 space-x-2 justify-end"></div>
                            </DataTableComponent>

                            {
                                allEmployeeData.length === 0 && (
                                    <div
                                        className="fixed bottom-0 right-10 w-16 h-16 mr-10 mb-6 cursor-pointer"
                                        id="box_btn"
                                    >
                                        <div className="text-right">
                                            <Menu className="relative inline-block text-left">
                                                <div>
                                                    <Menu.Button
                                                        onClick={() => setShowLevelModal(true)}
                                                        className="inline-flex justify-cente w-12 h-12 rounded-full text-sm font-medium text-white hover:bg-opacity-80 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 "
                                                        style={{ backgroundColor: `${primaryColor["700"]}` }}
                                                    >
                                                        <HiOutlinePlus className="w-full h-full p-3" />
                                                    </Menu.Button>
                                                </div>
                                            </Menu>
                                        </div>

                                    </div>)
                            }
                        </div>
                    </div>
                </div>
                <LevelAddModal
                    showLevelModal={showLevelModal}
                    setShowLevelModal={setShowLevelModal}
                    onSave={handleSaveLevels}
                />
            </div>
        </>
    );
};

export default EmployeeLevel;
